import React from 'react';
import * as Styles from './SearchResultsList.styles';
import * as PageStructures from '../../structure/PageStructures';

const NoResultsMessage: React.FunctionComponent = () => {
  return (
    <PageStructures.PageMain>
      <Styles.Container data-testid="NoResultsMessage">
        <Styles.Result>
          Sorry - we couldn’t find what you’re looking for!<br /><br />
          You can try again with a different search term or complete one of our top tasks:
        </Styles.Result>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th scope="col">Area</th>
                <th scope="col">Task</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><a href="/make-payment">Pay</a></td>
                <td><ul>
                  <li><a href="/make-payment">Make a payment for our&nbsp;services</a></li>
                </ul></td>
              </tr>
              <tr>
                <td><a href="/benefits">Benefits</a></td>
                <td><ul>
                  <li><a href="/benefits/apply-council-tax-support-or-housing-benefit">Benefits application</a></li>
                  <li><a href="/benefits/report-benefits-change">Report a benefits change</a></li>
                </ul></td>
              </tr>
              <tr>
                <td><a href="/bins-recycling-and-street-cleansing">Bins</a></td>
                <td><ul>
                  <li><a href="/bin-collections/garden-waste">Garden waste&nbsp;subscription</a></li>
                  <li><a href="/bin-collections/bulky-item-collections">Bulky item collection request</a></li>
                  <li><a href="/bin-collection-services/missed-bin-collections">Missed collections report</a></li>
                  <li><a href="/bin-collection-services/new-replacement-or-damaged-bins">New, replacement, or damaged bins request</a></li>
                </ul></td>
              </tr>
              <tr>
                <td><a href="/business-rates">Business rates</a></td>
                <td><ul>
                  <li><a href="/business-rates/make-business-rates-change">Business rates changes</a></li>
                  <li><a href="/business-rates">Discounts and exemptions</a></li>
                  <li><a href="/business-rates/report-business-rates-move">Move your&nbsp;business</a></li>
                </ul></td>
              </tr>
              <tr>
                <td><a href="/counciltax">Council tax</a></td>
                <td><ul>
                  <li><a href="/counciltax/moving-home">Move home</a></li>
                  <li><a href="/paycounciltax">Pay council tax</a></li>
                  <li><a href="/counciltax/council-tax-recovery/set-arrangement">Request an arrangement</a></li>
                  <li><a href="/counciltax/single-person-discount">Single person discount application</a></li>
                  <li><a href="/counciltax/student-discount">Student discount application</a></li>
                  <li><a href="/counciltax/council-tax-household-changes">Make a general change</a></li>
                </ul></td>
              </tr>
              <tr>
                <td><a href="/councillors-and-democracy">Democratic</a></td>
                <td><ul>
                  <li><a href="/elections-and-voting/register-vote">Register to vote</a></li>
                </ul></td>
              </tr>
              <tr>
                <td><a href="/environment">Environment and cleansing</a></td>
                <td><ul>
                  <li><a href="/street-cleansing/fly-tipping">Fly-tipping</a></li>
                  <li><a href="/environment/litter-dead-animals-and-street-cleaning">Litter and street cleaning</a></li>
                  <li><a href="/environment/noise">Noise</a></li>
                  <li><a href="/environment/odours-and-drains">Odour and drains</a></li>
                  <li><a href="/animals-dogs-and-pests/pest-control">Pest control</a></li>
                  <li><a href="/environment/smoke-and-bonfires">Smoke and bonfire</a></li>
                  <li><a href="/environment/issues-grass-cutting-trees-hedges-and-weeds">Grass cutting, trees and bushes</a></li>
                </ul></td>
              </tr>
              <tr>
                <td><a href="/health-and-wellbeing">Health</a></td>
                <td><ul>
                  <li><a href="/keeping-healthy/blood-tests">Book a blood test</a></li>
                </ul></td>
              </tr>
              <tr>
                <td><a href="/housing">Housing</a></td>
                <td><ul>
                  <li><a href="/council-housing/repairs">Repair request for a council house</a></li>
                  <li><a href="/housing/keyways-housing-register">Housing register application</a></li>
                </ul></td>
              </tr>
              <tr>
                <td><a href="/parking-roads-and-transport">Parking, roads and transport</a></td>
                <td><ul>
                  <li><a href="/blue-badges/apply-or-renew-blue-badge">Blue badge application</a></li>
                  <li><a href="/buses-and-transport/older-persons-bus-pass">Older person's bus pass application</a></li>
                  <li><a href="/parking-roads-and-transport/report-potholes-or-highway-problem">Report an issue with the highway</a></li>
                </ul></td>
              </tr>
              <tr>
                <td><a href="/planning-and-building-control">Planning and building control</a></td>
                <td><ul>
                  <li><a href="/applications-appeals-and-enforcement/comment-planning-application">Comment on an application</a></li>
                  <li><a href="/building-control-and-local-land-charges/request-building-control-quote">Request a building control quote</a></li>
                </ul></td>
              </tr>
              <tr>
                <td><a href="/births-deaths-and-marriages">Registrations</a></td>
                <td><ul>
                  <li><a href="/births-deaths-and-marriages/register-birth">Birth registrations</a></li>
                  <li><a href="/births-deaths-and-marriages/register-death">Death registrations</a></li>
                  <li><a href="/births-deaths-and-marriages/notice-marriage-or-civil-partnership">Notice of marriage or civil partnerships</a></li>
                </ul></td>
              </tr>
              <tr>
                <td><a href="/schools-and-education">Schools</a></td>
                <td><ul>
                  <li><a href="/schools-and-education/free-school-meals-and-pupil-premium">Free school meals application</a></li>
                  <li><a href="/primary-school-places/apply-primary-school-place">Primary school application</a></li>
                  <li><a href="/secondary-school-places/apply-secondary-school-place">Secondary school application</a></li>
                </ul></td>
              </tr>
              <tr>
                <td>Social services for <a href="/adult-social-services">adults</a> and <a href="/children-and-families">children</a></td>
                <td><ul>
                  <li><a href="/help-and-support-adults/get-social-care-help">Get social care help for an adult</a>&nbsp;</li>
                  <li><a href="/adult-social-care/report-safeguarding-concern-about-adult">Report a concern about an adult</a></li>
                  <li><a href="/children-and-families/report-concern-about-child">Report a concern about a child</a></li>
                </ul></td>
              </tr>
            </tbody>
          </table>
        </div>
      </Styles.Container>
    </PageStructures.PageMain>
  );
};

export default NoResultsMessage;
